import type { IconProps } from '@tabler/icons-react'
import type { ForwardRefExoticComponent, RefAttributes } from 'react'
import { forwardRef } from 'react'

export const SidekickDeeplinkIcon: ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>> = forwardRef<
  SVGSVGElement,
  IconProps
>(({ size = 24, stroke = 2, className, ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="3 3 20 20"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}>
    <path d="M19.49,13.87c.15-.6.23-1.22.23-1.87,0-4.35-3.52-7.87-7.87-7.87s-7.87,3.52-7.87,7.87,3.52,7.87,7.87,7.87c1.22,0,2.37-.28,3.39-.78v-5.23h4.25ZM13.25,15.07c-.05.23-.35.29-.48.09l-1.67-2.42s-.08-.08-.13-.1l-2.61-.89c-.23-.08-.24-.41-.01-.5l5.85-2.35c.2-.08.41.1.36.31l-1.3,5.86Z" />
    <path d="M19.49,13.87h-4.25v5.23" />
    <rect x="15.24" y="13.87" width="5.76" height="5.76" />
  </svg>
))

SidekickDeeplinkIcon.displayName = 'SidekickDeeplinkIcon'
